import { Building2, ChevronDown, Save, Upload } from "lucide-react";
import { useRef, useState } from "react";

const Organization = () => {
    const fileInputRef = useRef(null);

    const handleLogoUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                // Update the state with the new image preview URL
                setOrgData(prev => ({ ...prev, logo: reader.result }));
            };
            reader.readAsDataURL(file);
        }
    };

    const [orgData, setOrgData] = useState({
        name: 'TecoreLabs',
        industry: 'FinTech',
        size: '50-100',
        contactName: 'Ben Carter',
        contactEmail: 'ben@tecorelabs.com',
        timezone: 'Asia/Kolkata',
        logo: null
    });
    
    const handleSaveSettings = () => {
        alert("Settings saved successfully!");
    };
    
    return (<>
        <div className="space-y-6">
            <div>
                <h2 className="text-2xl font-black text-slate-900 tracking-tight mb-1 flex items-center gap-3">
                    <Building2 className="text-indigo-600" /> Organization Information
                </h2>
                <p className="text-sm font-medium text-slate-500">Configure core company details used across compliance reports.</p>
            </div>
            <div className="bg-white p-6 sm:p-8 rounded-3xl ring-1 ring-slate-200/60 shadow-sm">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="col-span-full mb-2">
                        <label className="block text-xs font-black text-slate-500 uppercase tracking-wider mb-2">Organization Logo</label>
                        <div className="flex items-center gap-6">
                            <div className="w-24 h-24 rounded-2xl bg-slate-50 ring-1 ring-slate-200 flex items-center justify-center text-slate-400 overflow-hidden">
                                {orgData.logo ? (
                                    <img src={orgData.logo} alt="Elora Logo" className="w-full h-full object-contain p-2" />
                                ) : (
                                    <Building2 size={32} />
                                )}
                            </div>

                            {/* Hidden file input */}
                            <input
                                type="file"
                                accept="image/*"
                                ref={fileInputRef}
                                onChange={handleLogoUpload}
                                className="hidden"
                            />

                            {/* Button triggers the hidden file input click */}
                            <button
                                onClick={() => fileInputRef.current?.click()}
                                className="px-4 py-2.5 bg-white ring-1 ring-slate-200 text-sm font-bold text-slate-600 rounded-xl hover:bg-slate-50 flex items-center gap-2 transition-all"
                            >
                                <Upload size={16} /> Upload Logo
                            </button>
                        </div>
                    </div>

                    <div>
                        <label className="block text-xs font-black text-slate-500 uppercase tracking-wider mb-2">Organization Name</label>
                        <input type="text" value={orgData.name} onChange={(e) => setOrgData({ ...orgData, name: e.target.value })} className="w-full bg-slate-50 ring-1 ring-slate-200 rounded-xl px-4 py-3 text-sm font-semibold text-slate-900 focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                    </div>
                    <div>
                        <label className="block text-xs font-black text-slate-500 uppercase tracking-wider mb-2">Industry</label>
                        <div className="relative">
                            <select value={orgData.industry} onChange={(e) => setOrgData({ ...orgData, industry: e.target.value })} className="w-full appearance-none bg-slate-50 ring-1 ring-slate-200 rounded-xl px-4 py-3 text-sm font-semibold text-slate-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 cursor-pointer">
                                {['Technology', 'FinTech', 'Healthcare', 'E-commerce', 'SaaS', 'Finance', 'Education', 'Other'].map(opt => <option key={opt}>{opt}</option>)}
                            </select>
                            <ChevronDown className="absolute right-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" />
                        </div>
                    </div>
                    <div>
                        <label className="block text-xs font-black text-slate-500 uppercase tracking-wider mb-2">Company Size</label>
                        <div className="relative">
                            <select value={orgData.size} onChange={(e) => setOrgData({ ...orgData, size: e.target.value })} className="w-full appearance-none bg-slate-50 ring-1 ring-slate-200 rounded-xl px-4 py-3 text-sm font-semibold text-slate-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 cursor-pointer">
                                {['1-10', '10-50', '50-100', '100-500', '500+'].map(opt => <option key={opt}>{opt}</option>)}
                            </select>
                            <ChevronDown className="absolute right-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" />
                        </div>
                    </div>
                    <div>
                        <label className="block text-xs font-black text-slate-500 uppercase tracking-wider mb-2">Primary Contact Name</label>
                        <input type="text" value={orgData.contactName} onChange={(e) => setOrgData({ ...orgData, contactName: e.target.value })} className="w-full bg-slate-50 ring-1 ring-slate-200 rounded-xl px-4 py-3 text-sm font-semibold text-slate-900 focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                    </div>
                    <div>
                        <label className="block text-xs font-black text-slate-500 uppercase tracking-wider mb-2">Primary Contact Email</label>
                        <input type="email" value={orgData.contactEmail} onChange={(e) => setOrgData({ ...orgData, contactEmail: e.target.value })} className="w-full bg-slate-50 ring-1 ring-slate-200 rounded-xl px-4 py-3 text-sm font-semibold text-slate-900 focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                    </div>
                    <div>
                        <label className="block text-xs font-black text-slate-500 uppercase tracking-wider mb-2">Timezone</label>
                        <div className="relative">
                            <select value={orgData.timezone} onChange={(e) => setOrgData({ ...orgData, timezone: e.target.value })} className="w-full appearance-none bg-slate-50 ring-1 ring-slate-200 rounded-xl px-4 py-3 text-sm font-semibold text-slate-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 cursor-pointer">
                                <option value="Asia/Kolkata">Asia/Kolkata (IST)</option>
                                <option value="America/New_York">America/New_York (EST)</option>
                                <option value="Europe/London">Europe/London (GMT)</option>
                            </select>
                            <ChevronDown className="absolute right-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" />
                        </div>
                    </div>
                </div>
                <div className="mt-8 pt-6 border-t border-slate-100 flex justify-end">
                    <button onClick={handleSaveSettings} className="px-6 py-3 bg-indigo-600 text-white text-sm font-bold rounded-xl shadow-md hover:bg-indigo-700 active:scale-95 transition-all flex items-center gap-2">
                        <Save size={16} /> Save Information
                    </button>
                </div>
            </div>
        </div>
    </>);
}

export default Organization;